import React from "react";
import { Skeleton } from "../../../../components/common/Skeleton";

export const PersonalDataSkeleton = () => {
  return (
    <div className="max-w-3xl mx-auto p-6">
      {/* Header skeleton */}
      <div className="flex items-center mb-8">
        <Skeleton className="w-16 h-16 rounded-full" />
        <div className="ml-4 flex flex-col gap-2">
          <Skeleton className="w-40 h-5 rounded" />
          <Skeleton className="w-24 h-4 rounded" />
        </div>
      </div>

      {/* Form skeleton */}
      <div className="bg-white shadow rounded-2xl p-6 flex flex-col gap-6">
        <Skeleton className="w-full h-10 rounded" />
        <Skeleton className="w-full h-10 rounded" />
        <Skeleton className="w-full h-10 rounded" />
        <Skeleton className="w-full h-20 rounded" />
        <Skeleton className="w-32 h-10 rounded self-end" />
      </div>
    </div>
  );
};
